import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuth, AuthProvider } from './context/AuthContext';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import PublicProfile from './pages/PublicProfile';
import LoggedOut from './pages/LoggedOut';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AboutUs from './pages/Aboutus';
import ContactUs from './pages/Contactus';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Refund from './pages/Refund';

const PrivateRoute = ({ children }: { children: React.ReactElement }) => {
  const { token, loading } = useAuth();
  if (loading) return <div style={{ minHeight: '100vh', background: '#F7F3EE' }} />;
  return token ? <>{children}</> : <Navigate to="/login" />;
};
function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={
          <PrivateRoute><Dashboard /></PrivateRoute>
        } />
        <Route path="/logged-out" element={<LoggedOut />} />
        <Route path="/adminUser/login"     element={<AdminLogin />} />
        <Route path="/adminUser/dashboard" element={<AdminDashboard />} />
        <Route path="/about"   element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/terms"   element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refund"  element={<Refund />} />
        <Route path="/:username" element={<PublicProfile />} />
      </Routes>
    </BrowserRouter>
  );
}

export default function Root() {
  return (
    <AuthProvider>
      <App />
    </AuthProvider>
  );
}